import { ChangeDetectionStrategy, Component, TemplateRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-reusable-grid-template',
  templateUrl: './reusable-grid-template.component.html',
  styleUrls: ['./reusable-grid-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReusableGridTemplateComponent implements ICellRendererAngularComp {
  public template: TemplateRef<any>;
  public context: {
    rowInfo?: { rowData: Record<string, any>; rowId: string; colId: string };
  } = {};
  private eParentEl!: HTMLElement;

  public agInit(params: ICellRendererParams): void {
    this.setTemplateAndParams(params);
    this.eParentEl = params.eParentOfValue;
    this.eParentEl.addEventListener('focus', this.onParentElFocus);
  }

  public refresh(params: ICellRendererParams): boolean {
    this.setTemplateAndParams(params);
    return false;
  }

  public setTemplateAndParams(params: ICellRendererParams): void {
    this.template = params['ngTemplate'];
    this.context = {
      rowInfo: {
        rowData: params.data,
        rowId: params.node.id,
        colId: params.colDef.field
      }
    };
  }

  public destroy(): void {
    this.eParentEl.removeEventListener('focus', this.onParentElFocus);
  }

  private onParentElFocus(event: FocusEvent): void {
    const currentEl = event.target as HTMLElement;
    const previousEl = event.relatedTarget as HTMLElement;
    const previousRowEl = findRowForEl(previousEl);
    const currentRow =
      currentEl && parseInt(currentEl.getAttribute('row-index')!, 10);
    const previousRow =
      previousRowEl && parseInt(previousRowEl.getAttribute('row-index')!, 10);

    const input = currentEl.querySelector('input');
    // Navigating forward, or unknown previous row
    if (!previousRow || currentRow >= previousRow) {
      // Focus on the first input
      input.focus();
    } else {
      // Navigating backwards
      // Focus on the last input
      input.focus();
    }
  }
}

const findRowForEl = (el: HTMLElement): HTMLElement | null => {
  let rowEl: HTMLElement | null = el;
  while (rowEl) {
    rowEl = rowEl.parentElement;
    if (rowEl && rowEl.getAttribute('role') === 'row') {
      return rowEl;
    }
  }
  return null;
};
